import { createAction, props } from '@ngrx/store';
import { InvoiceUpload } from '@invoice-upload/models/invoice-upload'

export const load = createAction('[Invoice Upload] Load', props<{ widgetConfigurationId: number }>());
export const loadComplete = createAction('[Invoice Upload] Load Complete', props < { widgetConfigurationId: number, invoices: InvoiceUpload[] }>());
